export const verifyCenturyWithGender = (idGenderCentury: number, year: number, sex: string): boolean => {
    const male = sex === 'M';
    const female = sex === 'F';

    if (male && idGenderCentury === 7 || female && idGenderCentury === 8 || idGenderCentury === 9) {
        return true;
    }
    if (year >= 1900 && year <= 1999) {
        return male && idGenderCentury === 1 || female && idGenderCentury === 2;
    }
    if (year >= 1800 && year <= 1899) {
        return male && idGenderCentury === 3 || female && idGenderCentury === 4;
    }
    if (year >= 2000) {
        return male && idGenderCentury === 5 || female && idGenderCentury === 6;
    }

    return false;
};

export const verifyCountryZone = (idCountryZone: number): boolean =>
    idCountryZone === 80 || idCountryZone === 99 || idCountryZone >= 1 && idCountryZone <= 52;

export const verifyCheckSum = (value: string, idCheckSum: number): boolean => {
    const control = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
    const slicedIdArr = value
        .slice(0, 12)
        .split('')
        .map(Number);
    const checkSumValue = slicedIdArr.reduce((acc, item, index) => acc + item * control[index], 0);
    const reminder = checkSumValue % 11;

    return reminder === 10 ? true : reminder === Number(idCheckSum);
};
